import { createContext, useContext, useRef, useCallback } from "react";
import axios from "axios";

const ProductContext = createContext(null);

const CACHE_TTL = 30 * 60 * 1000;

export function ProductProvider({ children }) {
  const cacheRef = useRef({});
  const pendingRef = useRef({});

  const fetchProducts = useCallback(async (cid) => {
    const cached = cacheRef.current[cid];
    if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
      return cached.data;
    }

    if (pendingRef.current[cid]) {
      return pendingRef.current[cid];
    }

    const request = axios
      .post(
        `https://api.wowfashions.ae/api/Websiteinfo/GetVendorProduct/${cid}/0`,
      )
      .then((res) => {
        const data = {
          categories: res.data.categories || [],
          products: res.data.products || [],
        };
        cacheRef.current[cid] = { data, timestamp: Date.now() };
        return data;
      })
      .finally(() => {
        delete pendingRef.current[cid];
      });

    pendingRef.current[cid] = request;
    return request;
  }, []);

  return (
    <ProductContext.Provider value={{ fetchProducts }}>
      {children}
    </ProductContext.Provider>
  );
}

export function useProducts() {
  const ctx = useContext(ProductContext);
  if (!ctx) {
    throw new Error("useProducts must be used within a ProductProvider");
  }
  return ctx;
}
